import { useEffect } from "react";
import { updateCanvasStoryboards } from "@/store/supabaseSlice";
import { useActiveCanvas } from "@/utils/utils";
import { useDispatch } from "react-redux";
import { useSession } from "@clerk/clerk-react";
import { useSupabaseStore } from "@/store/zustand/supabaseStore";

export const usePruneInactiveStoryboards = () => {
  const dispatch = useDispatch();
  const { session } = useSession();

  const canvas = useActiveCanvas();
  const INACTIVE_PERIOD = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds
  const supabaseClient = useSupabaseStore((state) => state.supabaseClient);

  useEffect(() => {
    const prune = async () => {
      let inactiveStoryboards = [];
      let activeStoryboards = [];

      if (canvas?.storyboards) {
        canvas.storyboards.forEach((storyboard) => {
          if (!storyboard.deleted) {
            // @ts-expect-error TS2345
            activeStoryboards.push(storyboard);
            return;
          }

          const deletedAt = storyboard.deleted_at;
          if (!deletedAt) {
            // @ts-expect-error TS2345
            inactiveStoryboards.push(storyboard);
            return;
          }

          // deleted_at is either a
          // a) Firestore Timestamp object (with _seconds and _nanoseconds properties)
          // b) An ISO string
          let deletedAtDate;

          if (deletedAt._seconds) {
            deletedAtDate = new Date(
              deletedAt._seconds * 1000 + deletedAt._nanoseconds / 1000000
            );
          } else {
            deletedAtDate = new Date(deletedAt);
          }

          const now = new Date();
          const inactiveThreshold = new Date(now.getTime() - INACTIVE_PERIOD);

          const isInactive = deletedAtDate < inactiveThreshold;

          if (isInactive) {
            // @ts-expect-error TS2345
            inactiveStoryboards.push(storyboard);
          } else {
            // @ts-expect-error TS2345
            activeStoryboards.push(storyboard);
          }
        });

        if (inactiveStoryboards.length) {
          await updateCanvasStoryboards(
            supabaseClient,
            dispatch,
            activeStoryboards,
            canvas
          );
        }
      }
    };

    if (session && canvas?.storyboards) {
      prune();
    }
  }, [canvas?.storyboards, Boolean(session)]);
};
